import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';
import i18n from 'i18n-js';
import { bool, func, node, number, string } from 'prop-types';

import Image from '~/components/Image';

import style from './TaskContent.module.scss';

function TaskContent({ completed, text, bonus, src, path, children, onClick }) {
  return (
    <div
      className={classNames(style.taskContent, { completed })}
      onClick={onClick}
    >
      <div className={style.wrapper}>
        <div className={style.completedOverlay} />
        <FontAwesome
          name="check-circle"
          className={style.checkMark}
        />
      </div>
      {completed ? i18n.t('DailyView_tomorrow') : text}
      <div className={style.imageContainer}>
        <Image
          src={src}
          path={path}
          alt="Reward"
        />
        {bonus && <div className={style.bonus}>{`${bonus}x`}</div>}
      </div>
      {children}
    </div>
  );
}

export const propTypes = {
  completed: bool,
  text: string.isRequired,
  bonus: number,
  src: string,
  path: string,
  children: node,
  onClick: func,
};

TaskContent.propTypes = propTypes;

export default TaskContent;
